import { Head, Link } from "@inertiajs/react"
import { ArrowLeft } from "lucide-react"
import { AdminShell } from "@/components/AdminShell"
import { PageHeader } from "@/components/PageHeader"
import { AutomationForm } from "@/components/admin/AutomationForm"
import type { AutomationDetail, LanguageOptions, ScopeOption } from "@/types/automation"

const DESCRIPTION =
  "Create an automation: name it, write the default message, and supply the roster query that decides who it reaches."

export default function AdminAutomationsNew({
  automation,
  scope_options,
  language_options,
}: {
  automation: AutomationDetail
  scope_options: ScopeOption[]
  /** Deferred: undefined until the roster has been asked. */
  language_options?: LanguageOptions
}) {
  return (
    <>
      <Head title="New automation">
        <meta name="description" content={DESCRIPTION} />
        <meta property="og:title" content="New automation" />
        <meta property="og:description" content={DESCRIPTION} />
      </Head>
      <AdminShell>
        <Link
          href="/admin/automations"
          className="mb-4 inline-flex items-center gap-1.5 text-sm no-underline"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to automations
        </Link>

        <PageHeader
          title="New automation"
          description="Describe what makes a member eligible. Scope is never your problem here — the app narrows the results to whatever each organization targets."
        />

        <AutomationForm
          automation={automation}
          scopeOptions={scope_options}
          languageOptions={language_options}
          submitLabel="Create automation"
        />
      </AdminShell>
    </>
  )
}
